<template>
    <div id="app">
        <div class="container-fluid mt-3">
            <div class="mb-5">
                <center>
                    <h1>Tính toán điểm số</h1>
                    <small>
                        <i>Made by <a href="http://vuduchong.com" target="_blank">vuduchong.com</a></i>
                    </small>
                </center>
            </div>

            <div class="row">
                <div class="col-6 col-sm-3 col-md-2 mb-4">
                    <h4>Số người</h4>
                </div>
                <div class="col-6 col-sm-1 col-md-1 mb-4">
                    <select class="form-control" v-model="qty_user">
                        <option v-for="item in 10" :value="item" :key="item">
                            {{ item }}
                        </option>
                    </select>
                </div>

                <div class="col-12 col-sm-4 col-md-6 text-center mb-4">
                    <h4>Tổng điểm : {{ score_total }}</h4>
                </div>

                <div class="col-12 col-sm-4 col-md-3 text-end mb-4">
                    <h4>Số lượt: {{ row }}</h4>
                    <a href="javascript:;" v-on:click="clearCache()"><i>Clear Cache</i></a>
                </div>
            </div>
            <hr />

            <div class="d-md-flex justify-content-around pt-3 pb-2 block-score">
                <div v-for="(item, index) in score_user" :key="index" class="block-item">
                    <col-user :score_user_item="score_user[index]" :index="index" />
                </div>
            </div>
            <hr />
            <center>
                <button class="text-center btn btn-success btn-lg w-100 mb-3" v-on:click="addRow()">
                    <b-icon icon="plus-circle" aria-hidden="true"></b-icon> Thêm
                </button>

                <button class="text-center btn btn-outline-danger btn-sm" v-on:click="deleteRow()" v-if="row > 0">
                    <b-icon icon="trash" aria-hidden="true"></b-icon> Xóa dòng cuối
                </button>
            </center>
        </div>
    </div>
</template>

<script>
    import ColUser from "./components/ColUser.vue";
    export default {
        components: { ColUser },
        data() {
            return {
                qty_user: 4,
                row: 0,
                row_old: 0,
                score_user: [],
            };
        },
        computed: {
            score_total() {
                var total_root = 0;
                this.score_user.forEach(e => {
                    var total_col = 0;
                    e.forEach(i => {
                        i = parseFloat(i);
                        if(!isNaN(i)) {
                            total_col += i;
                        }
                    })
                    total_root += total_col;
                })
                localStorage.setItem('data-score', JSON.stringify(this.score_user))
                return total_root;
            }
        },
        created() {
            var data_score = localStorage.getItem('data-score'),
                data_score = JSON.parse(data_score)

            if(data_score != null && data_score != undefined && data_score.length > 0 && data_score[0].length > 0) {
                this.score_user = data_score
                this.row_old = this.row = this.score_user[0].length
            } else {
                for(var i = 0; i < this.qty_user; i++) {
                    this.score_user.push([])
                }
            }    
        },
        watch: {
            qty_user(qty_user) {
                var score_user_length = this.score_user.length;

                if(qty_user > score_user_length) {

                    for(var i = 1; i <= qty_user; i++) {

                        if(i > score_user_length) {

                            var score = [];
                            for(var j = 0; j < this.row; j++) {
                                score.push('')
                            }
                            
                            this.score_user.push(score)
                        }
                    }

                } else if(qty_user < score_user_length) {

                    for(var i = 1; i <= score_user_length; i++) {
                        if(i > qty_user) {
                            this.score_user.pop()
                        }
                    }

                }
            },
            row(newVal, oldVal) {
                if(this.row_old == newVal) return

                if(newVal > oldVal) {
                    this.score_user.map(el => {
                        el.push('')
                    })
                }

                if(newVal < oldVal) {
                    this.score_user.map(el => {
                        el.pop()
                    })
                }
            }
        },
        methods: {
            addRow() {
                this.row++;
            },
            deleteRow() {
                if(this.row > 0) {
                    if(confirm("Are you sure ?")) {
                        this.row--;
                    }
                }
            },
            clearCache() {
                if(confirm('Do you want delete cache ?')) {
                    localStorage.removeItem('data-score');
                    this.score_user = []
                    for(var i = 0; i < this.qty_user; i++) {
                        this.score_user.push([])
                    }
                    localStorage.setItem('data-score', JSON.stringify(this.score_user))
                    location.reload()
                }
            }
        },
    };
</script>


// WEBPACK FOOTER //
// src/App.vue